import Api from "@/services/Api";

export default {
 
  getAll() {
    return Api().get("cartons");
  },

  delete(id) {
    return Api().delete(`cartons/${id}`);
  },

  create: (data) => {
    return Api().post('cartons', data)
  },

  update(data) {
    return Api().put(`cartons/${data.id}`, data);
  }

};